export default __webpack_public_path__ + "static/media/ic_error.708d36bf.svg";